import React from 'react';
import {
  IconProps,
  IconSvgWrapper,
} from '@grnhse/seedling/lib/birch/icons/base';
import { IconTheme } from '@grnhse/seedling/lib/birch/icons/theme';

const GithubIcon = (props: IconProps) => {
  const { color = IconTheme.default.color } = props;
  return (
    <IconSvgWrapper {...props}>
      <path
        fill={color}
        // eslint-disable-next-line max-len
        d="M12 2C6.477 2 2 6.484 2 12.021c0 4.428 2.865 8.184 6.839 9.504.5.091.682-.217.682-.483 0-.237-.009-.868-.014-1.703-2.782.605-3.369-1.342-3.369-1.342-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.53 1.031 1.53 1.031.892 1.529 2.341 1.088 2.91.832.091-.647.35-1.088.636-1.338-2.221-.253-4.555-1.112-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.025A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.295 2.748-1.025 2.748-1.025.546 1.378.202 2.397.1 2.65.64.7 1.028 1.595 1.028 2.688 0 3.847-2.337 4.695-4.566 4.944.359.309.678.919.678 1.854 0 1.338-.012 2.419-.012 2.749 0 .268.18.579.688.481C19.138 20.203 22 16.447 22 12.021 22 6.484 17.523 2 12 2z"
      />
    </IconSvgWrapper>
  );
};

export default GithubIcon;
